/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedList, useIntl } from 'react-intl'

export type FurnishingAndEquipmentLabelProps = {
  equipped?: boolean
  furnished?: boolean
}

function FurnishingAndEquipmentLabel (props: FurnishingAndEquipmentLabelProps) {
  const { equipped, furnished } = props
  const intl = useIntl()
  const list = []

  if (furnished) {
    list.push(intl.formatMessage({
      id: 'furnished',
      defaultMessage: 'Meublé'
    }))
  } else if (furnished === false) {
    list.push(intl.formatMessage({
      id: 'not_furnished',
      defaultMessage: 'Non meublé'
    }))
  }

  if (equipped) {
    list.push(intl.formatMessage({
      id: 'equipped',
      defaultMessage: 'Équipé'
    }))
  } else if (equipped === false) {
    list.push(intl.formatMessage({
      id: 'not_equipped',
      defaultMessage: 'Non équipé'
    }))
  }

  return (
    <FormattedList
      value={list}
      type="conjunction"
    />
  )
}

export default FurnishingAndEquipmentLabel
